import { render, staticRenderFns } from "./diamond_statistics.vue?vue&type=template&id=23c09e60&scoped=true"
import script from "./diamond_statistics.vue?vue&type=script&lang=ts"
export * from "./diamond_statistics.vue?vue&type=script&lang=ts"
import style0 from "./diamond_statistics.vue?vue&type=style&index=0&id=23c09e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c09e60",
  null
  
)

export default component.exports